import { render, staticRenderFns } from "./oscity-gobierno.vue?vue&type=template&id=26a1a428&scoped=true"
import script from "./oscity-gobierno.vue?vue&type=script&lang=js"
export * from "./oscity-gobierno.vue?vue&type=script&lang=js"
import style0 from "./oscity-gobierno.vue?vue&type=style&index=0&id=26a1a428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a1a428",
  null
  
)

export default component.exports